module.exports = __webpack_public_path__ + "static/wechat_public_account-b4661a52daa981f0058d0fbbdcaeb5ac.jpeg";